'use strict';

var $ = require('jquery'),
    window = require('window'),
    document = window.document,
    screen = window.screen,
    isEmptyJQuery = require('./functions/lang/is-empty-jquery'),
    hasAttr = require('./functions/jquery/has-attribute'),
    toggleAttr = require('./functions/jquery/toggle-attribute'),
    setCursorPosition = require('./functions/jquery/set-cursor-position'),
    getCursorPosition = require('./functions/jquery/get-cursor-position'),
    setDecimalFormat = require('./functions/math/set-decimal-format'),
    isEmpty = require('./functions/lang/is-empty'),
    isDefined = require('./functions/lang/is-defined'),
    isDefinedAndNotNull = require('./functions/lang/is-defined-and-not-null'),
    setClass = require('./functions/jquery/set-class'),
    isInt = require('./functions/lang/is-int'),
    getParams = require('./functions/url/get-params'),
    supportPlaceholder = require('./functions/browser/support-placeholder'),
    cachedScript = require('./functions/browser/cached-script'),
    windowOpen = require('./functions/browser/window-open');

if (!window.$) {
    window.$ = $;
}

if (!window.jQuery) {
    window.jQuery = $;
}

(function ($) {

    $.fn.extend({
        /**
         * Controlla l'esistenza di un elemento jquery tramite la sua lunghezza
         * @syntax $( element ).exist();
         */
        exist: function () {
            return !isEmptyJQuery(this);
        },

        /**
         * Estensione per controllare se un elemento del DOM ha un determinato attributo dichiarato, non vuoto, non nullo
         * @param name Selector
         * @syntax $('#idElement').hasAttr('data-text'), $('.className #idElement').hasAttr('title')
         */
        hasAttr: function (name) {
            return hasAttr(name, this);
        },

        /**
         * Estensione che permette di effettuare il toggle di un attributo come .toggleClass() per una classe
         * @param attr
         * @param turnOn
         * @returns {*}
         * @syntax $(selector).toggleAttr('required');
         * @syntax $(selector).toggleAttr('required', true);
         */
        toggleAttr: function (attr, turnOn) {
            if(turnOn){
                return this.attr(attr, attr);
            }

            return toggleAttr(attr, this);
        },

        /**
         * Sposta il cursore di un input element ad una posizione indicata da pos
         * @syntax $( element ).setCursorPosition(5);
         */
        setCursorPosition: function (pos) {
            return setCursorPosition(pos, this)
        },

        /**
         * Ritorna la posizione attuale del cursore all'interno di un input field
         * @syntax $( element ).getCursorPosition();
         */
        getCursorPosition: function () {
            return getCursorPosition(this);
        }
    });

    $.extend({
        /**
         * Metodo che setta un numero in formato decimale
         * @param initString
         */
        setDecimalFormat: function(initString){
            return setDecimalFormat(initString, true);
        },

        /**
         * Estensione per controllare il valore empty di un determinato selettore.
         * @param mixed
         * @syntax $.isEmpty($('#idElement')), $.isEmpty($('.className')), $.isEmpty($("p").siblings(".selected")), $.isEmpty("testo"), $.isEmpty(1232323)
         */
        isEmpty: isEmpty,

        /**
         * Estensione per verificare la non indeterminatezza di un parametro(GENERICO). Ex: array, int, object...
         * @param par
         * @syntax $.isDefined("pippo"), $.isDefined(null), $.isDefined($("p").siblings(".selected")), $.isDefined(0), $.isDefined(undefined)
         *         result: [T,T,T,T,F]
         * @return {boolean}
         */
        isDefined: isDefined,

        /**
         * Estensione che verifica se una variabile è definita e strettamente diversa da null.
         * @param par
         * @returns {boolean}
         */
        isDefinedAndNotNull: isDefinedAndNotNull,

        /**
         * Metodo per aggiungere/togliere una classe ricorsivamente a elementi di un array
         * @param aItem Array [ Array di elementi su cui performare l'azione ]
         * @param nameClass string [ Specifica il nome della classe dalla quale performare l'azione ES: 'pointer', 'wait', 'default' ]
         * @param type string Specifica l'azione da eseguire ex: add, remove. Supportate ad ora addClass, removeClass
         * @syntax $.setClass( new Array( .... ), 'nomeClasse' ) ;
         */
        setClass: setClass,

        /**
         * Metodo che verifica se il numero e' un intero
         * @param number verifica che l'argomento passato sia un numero intero
         * @returns {boolean}
         * @syntax [$.isInt('abc'), $.isInt(200), $.isInt(10.2), $.isInt('200')] result:[F,T,F,F]
         */
        isInt: isInt,

        /**
         * Metodo che data una url genera un oggetto
         * @param url
         * @returns {Object}
         */
        deparam: function (url) {
            if (url.search(/\?/) === 0) {
                url = url.slice(1);
            }

            return getParams(url);
        },

        /**
         * Verifica il supporto o meno dei placeholder html nei diversi browser
         * @param updatejqsupport
         * @returns {boolean}
         * @syntax $.supportPlaceholder([true|false]);
         *
         */
        supportPlaceholder: function (updatejqsupport) {
            var updateJQ = isDefined(updatejqsupport) ? updatejqsupport : true,
                bReturn = supportPlaceholder();

            if (isDefined($.support) && updateJQ) {
                $.support.placeholder = bReturn;
            }

            return bReturn;
        }
    });

    /**
     * Cached script. override caching script default by getScript jquery
     * @param url
     * @param options
     * @returns {ajax|*|ajax|ajax}
     */
    $.cachedScript = cachedScript;

    /**
     * Apre una finestra popup
     * @param page
     * @param title
     * @param width
     * @param height
     * @returns {*}
     */
    $.windowOpen = windowOpen;

    /**
     * Si occupa di convertire una query string di parametri in un oggetto
     * @param url
     * @returns {{}}
     */
    $.getUrlParams = function (url) {
        url = url || window.location.search;

        if (url.search(/\?/) === 0) {
            url = url.slice(1);
        }

        return getParams(url, true);
    };
})($);

module.exports = $;
